var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$router.currentRoute.path !== '/login')?_c('appHeader'):_vm._e(),_c('v-main',[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('router-view')],1)],1),_c('session-end-viewer'),_c('video-call-viewer'),_c('image-viewer'),_c('recognition')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }